import { Popover } from '@mui/material';
import { useState } from 'react';
import { ColorResult, SketchPicker } from 'react-color';

interface ColorInputProps {
  label?: string;
  color: string;
  onColorChange: (color: string) => void;
  width?: string;
  marginLeft?: string;
}

export const ColorInput = ({
  color,
  onColorChange,
  width = '30px',
  marginLeft = 'auto',
}: ColorInputProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <div
        style={{
          height: '1rem',
          width,
          minWidth: '30px',
          marginLeft,
          backgroundColor: color,
          border: '1px solid darkgray',
          borderRadius: '2px',
          cursor: 'pointer',
        }}
        onClick={handleClick}
      />

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div style={{ padding: 0 }}>
          <SketchPicker
            color={color}
            className="sketchPicker"
            width="16rem"
            disableAlpha
            onChangeComplete={(c: ColorResult) => onColorChange(c.hex)}
          />
        </div>
      </Popover>
    </>
  );
};
